import { Component, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import gsap from 'gsap';
import SplitType from 'split-type';
@Component({
    selector: 'app-loader-pages',
    templateUrl: './loader-pages.component.html',
    styleUrls: ['./loader-pages.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderPagesComponent implements OnInit {

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    const masterTimeline = gsap.timeline({ repeat: -1, repeatDelay: 2 });

    const text = SplitType.create('#comp_name');
    masterTimeline.from(text.chars, {
      duration: 0.3,
      opacity: 0,
      y: 20,
      stagger: {
        amount: 1,
        each: 1,
        from: "start"
      },
      delay: 1
    });

    const slogan = this.el.nativeElement.querySelector('#comp_slogan');
    masterTimeline.from(slogan, {
      duration: 0.3,
      opacity: 0,
      y: "100%",
      stagger: {
        amount: 1,
        each: 1,
        from: "start"
      },
      delay: 0.3
    });

  }

}
